import { api } from '../client';

export interface PayrollTransactionHistory {
  uuid: string;
  name: string;
  abn: string;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  head_office_location: string;
  created_at: string;
  updated_at: string;
  donation_payout_status: string;
  status_uuid: string;
  status_name: string;
  total_payout: number;
  transaction_date: string;
}

export interface PayrollTransactionHistoryFilters {
  page?: number;
  per_page?: number;
  phrase?: string;
  employer_uuid?: string;
  start_date?: string;
  end_date?: string;
}

export interface PayrollTransactionHistoryResponse {
  success: boolean;
  data: PayrollTransactionHistory[];
  paging: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
    from: number;
    to: number;
  };
  message?: string;
}

export class PayrollTransactionHistoryService {
  static async getPayrollTransactionHistory(
    filters: PayrollTransactionHistoryFilters = {}
  ): Promise<PayrollTransactionHistoryResponse> {
    try {
      const params = new URLSearchParams();
      
      if (filters.page) params.append('page', filters.page.toString());
      if (filters.phrase) params.append('phrase', filters.phrase);
      if (filters.employer_uuid) params.append('employer_uuid', filters.employer_uuid);
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);

      const response = await api.get<PayrollTransactionHistoryResponse>(
        `/admin/payroll-transaction-history?${params.toString()}`
      );

      return response.data;
    } catch (error: any) {
      return {
        success: false,
        data: [],
        paging: {
          current_page: 0,
          last_page: 1,
          per_page: 15,
          total: 0,
          from: 0,
          to: 0
        },
        message: error.response?.data?.message || 'Failed to fetch payroll transaction history'
      };
    }
  }

  static formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    
    try {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    } catch {
      return 'N/A';
    }
  }

  static formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }
}

export default PayrollTransactionHistoryService; 